import {
  barcelonaStar,
  blueTracktorBoys,
  blueTracktorGirls,
  dinasorBoys,
  dinasorGirls,
  elzasKingdom,
  fcAstana,
  fcKairat,
  footballStar,
  garryPotterBoys,
  garryPotterGirls,
  hantix,
  hokkeyChampionWay,
  kazakhBatyr,
  ladyBug,
  mashaBearBoys,
  mashaBearGirls,
  pawPatrol,
  princesses,
  kuromi,
  raceMcqueen,
  real,
  rusalochka,
  snichBoys,
  snichGirls,
  sonicXBoys,
  sonicXGirls,
  spiderman,
  strangeBoys,
  strangeGirls,
  threeCatBoys,
  threeCatGirls,
  zveropolis_boys,
  zveropolitsGirls,
  elsa,
} from "../assets";

export type Category = "all" | "boys" | "girls" | "two";

export interface Book {
  id: number;
  title: string;
  description: string;
  image: string;
  category: Category;
  badge: string;
  color: string;
  textColor: string;
  pagesDir: string;
}

export const colors: Record<Category, string> = {
  all: "#E6DEFF",
  boys: "#98E2FF",
  girls: "#F8C6FF",
  two: "#FFE2CD",
};

export const textColors: Record<Category, string> = {
  all: "#4731A4",
  boys: "#00667F",
  girls: "#ED00D1",
  two: "#F27B1A",
};

export const books: Book[] = [
  // --- Зверополис ---
  {
    id: 1,
    title: "Зверополис",
    description: "Стань напарником Джуди Хопс",
    image: zveropolitsGirls,
    category: "girls",
    badge: "Для девочек",
    color: colors.girls,
    textColor: textColors.girls,
    pagesDir: "zveropolis_girls",
  },
  {
    id: 29,
    title: "Зверополис",
    description: "Стань напарником Джуди Хопс",
    image: zveropolis_boys,
    category: "boys",
    badge: "Для мальчиков",
    color: colors.boys,
    textColor: textColors.boys,
    pagesDir: "zveropolis_boys",
  },

  // --- Звезда Барселоны ---
  {
    id: 2,
    title: "Звезда Барселоны!",
    description: "Выйди на «Камп Ноу» и стань новой легендой великого клуба!",
    image: barcelonaStar,
    category: "boys",
    badge: "Для мальчиков",
    color: colors.boys,
    textColor: textColors.boys,
    pagesDir: "barca",
  },

  // --- Леди Баг ---
  {
    id: 3,
    title: "Леди Баг!",
    description: "Верни музыку и смех в Париж вместе с Леди Баг!",
    image: ladyBug,
    category: "girls",
    badge: "Для девочек",
    color: colors.girls,
    textColor: textColors.girls,
    pagesDir: "lady_bug",
  },

  // --- Русалочка ---
  {
    id: 4,
    title: "Русалочка",
    description: "Победи морскую ведьму и спаси подводный мир!",
    image: rusalochka,
    category: "girls",
    badge: "Для девочек",
    color: colors.girls,
    textColor: textColors.girls,
    pagesDir: "rusalochka",
  },

  // --- Гарри Поттер ---
  {
    id: 5,
    title: "Гарри Поттер",
    description: "Ваше письмо из Хогвартса пришло!",
    image: garryPotterGirls,
    category: "girls",
    badge: "Для девочек",
    color: colors.girls,
    textColor: textColors.girls,
    pagesDir: "harry_poter_girls",
  },
  {
    id: 32,
    title: "Гарри Поттер",
    description: "Ваше письмо из Хогвартса пришло!",
    image: garryPotterBoys,
    category: "boys",
    badge: "Для мальчиков",
    color: colors.boys,
    textColor: textColors.boys,
    pagesDir: "harry_potter_boys",
  },

  // --- Хоккей ---
  {
    id: 6,
    title: "Хоккей Путь Чемпиона!",
    description: "Выходи на лёд и стань лучшим игроком мира!",
    image: hokkeyChampionWay,
    category: "boys",
    badge: "Для мальчиков",
    color: colors.boys,
    textColor: textColors.boys,
    pagesDir: "hockey",
  },

  // --- Қазақ Батыры ---
  {
    id: 7,
    title: "Қазақ Батыры",
    description: "Стань отважным защитником Великой степи!",
    image: kazakhBatyr,
    category: "boys",
    badge: "Для мальчиков",
    color: colors.boys,
    textColor: textColors.boys,
    pagesDir: "kazakh_batyr",
  },

  // --- В королевстве Эльзы ---
  {
    id: 8,
    title: "В королевстве Эльзы",
    description: "Открой магию льда и пройди через заснеженные горы вместе!",
    image: elzasKingdom,
    category: "two",
    badge: "Для двоих детей",
    color: colors.two,
    textColor: textColors.two,
    pagesDir: "cold_heart_dariya_dilnaz",
  },
  {
    id: 9,
    title: "В королевстве Эльзы",
    description: "Открой магию льда и пройди через заснеженные горы вместе!",
    image: elsa,
    category: "girls",
    badge: "Для девочек",
    color: colors.girls,
    textColor: textColors.girls,
    pagesDir: "cold_heart_rayana",
  },

  // --- Синий трактор ---
  {
    id: 10,
    title: "Синий трактор!",
    description:
      "Узнай, смогут ли старые друзья помириться с новым Синим Трактором!",
    image: blueTracktorBoys,
    category: "boys",
    badge: "Для мальчиков",
    color: colors.boys,
    textColor: textColors.boys,
    pagesDir: "blue_tractor_boys",
  },
  {
    id: 39,
    title: "Синий трактор!",
    description:
      "Узнай, смогут ли старые друзья помириться с новым Синим Трактором!",
    image: blueTracktorGirls,
    category: "girls",
    badge: "Для девочек",
    color: colors.girls,
    textColor: textColors.girls,
    pagesDir: "blue_tractor_girls",
  },

  // --- Принцессы ---
  {
    id: 11,
    title: "Принцессы",
    description: "Помоги принцессам найти потерянный подарок!",
    image: princesses,
    category: "girls",
    badge: "Для девочек",
    color: colors.girls,
    textColor: textColors.girls,
    pagesDir: "princesses",
  },

  // --- Гонка с Маквином ---
  {
    id: 12,
    title: "Гонка с Маквином!",
    description: "Врубай скорость и стань чемпионом гонок!",
    image: raceMcqueen,
    category: "boys",
    badge: "Для мальчиков",
    color: colors.boys,
    textColor: textColors.boys,
    pagesDir: "cars",
  },

  // --- Звезда Футбола ---
  {
    id: 13,
    title: "Звезда Футбола",
    description: "Стань легендой поля и забей самый рождающий гол!",
    image: footballStar,
    category: "boys",
    badge: "Для мальчиков",
    color: colors.boys,
    textColor: textColors.boys,
    pagesDir: "football_star",
  },

  // --- Соник X ---
  {
    id: 15,
    title: "Соник X",
    description:
      "Стань быстрее ветра и помоги Сонику победить. Это наша история!",
    image: sonicXBoys,
    category: "boys",
    badge: "Для мальчиков",
    color: colors.boys,
    textColor: textColors.boys,
    pagesDir: "sonicx_boys",
  },
  {
    id: 36,
    title: "Соник X",
    description:
      "Стань быстрее ветра и помоги Сонику победить. Это наша история!",
    image: sonicXGirls,
    category: "girls",
    badge: "Для девочек",
    color: colors.girls,
    textColor: textColors.girls,
    pagesDir: "sonicx_girls",
  },

  // --- Динозавры ---
  {
    id: 16,
    title: "Динозавры",
    description: "Отправляйся в опасное путешествие в мир до-нозавров!",
    image: dinasorBoys,
    category: "boys",
    badge: "Для мальчиков",
    color: colors.boys,
    textColor: textColors.boys,
    pagesDir: "dinasor_boys",
  },
  {
    id: 31,
    title: "Динозавры",
    description: "Отправляйся в опасное путешествие в мир до-нозавров!",
    image: dinasorGirls,
    category: "girls",
    badge: "Для девочек",
    color: colors.girls,
    textColor: textColors.girls,
    pagesDir: "dinasor_girls",
  },

  // --- Щенячий патруль ---
  {
    id: 17,
    title: "Щенячий патруль",
    description: "Новая история и новая миссия для героев!",
    image: pawPatrol,
    category: "boys",
    badge: "Для мальчиков",
    color: colors.boys,
    textColor: textColors.boys,
    pagesDir: "paw_patrol_ramin",
  },
  // --- Хантрикс ---
  {
    id: 18,
    title: "Хантрикс",
    description: "Стань героиней и защити мир от зла!",
    image: hantix,
    category: "girls",
    badge: "Для девочек",
    color: colors.girls,
    textColor: textColors.girls,
    pagesDir: "hantrix",
  },

  // --- Стич ---
  {
    id: 19,
    title: "Стич",
    description: "Поймай золотой стич и стань чемпионом!",
    image: snichBoys,
    category: "boys",
    badge: "Для мальчиков",
    color: colors.boys,
    textColor: textColors.boys,
    pagesDir: "snich_boys",
  },
  {
    id: 35,
    title: "Стич",
    description: "Поймай золотой стич и стань чемпионом!",
    image: snichGirls,
    category: "girls",
    badge: "Для девочек",
    color: colors.girls,
    textColor: textColors.girls,
    pagesDir: "snich_girls",
  },

  // --- Человек-паук ---
  {
    id: 20,
    title: "Человек-паук",
    description:
      "После укуса паука он получил необычные способности и теперь защищает город.",
    image: spiderman,
    category: "boys",
    badge: "Для мальчиков",
    color: colors.boys,
    textColor: textColors.boys,
    pagesDir: "spiderman",
  },

  // --- ОСД ---
  {
    id: 21,
    title: "ОСД",
    description:
      "Героиня с друзьями отправляется спасать пропавшего мальчика. История о дружбе и смелости.",
    image: strangeGirls,
    category: "girls",
    badge: "Для девочек",
    color: colors.girls,
    textColor: textColors.girls,
    pagesDir: "strange_girls",
  },
  {
    id: 37,
    title: "ОСД",
    description:
      "Герой с друзьями отправляется спасать пропавшего. История о дружбе и смелости.",
    image: strangeBoys,
    category: "boys",
    badge: "Для мальчиков",
    color: colors.boys,
    textColor: textColors.boys,
    pagesDir: "strange_boys",
  },

  // --- Три Кота ---
  {
    id: 22,
    title: "Три Кота",
    description:
      "Встречай новых друзей и вместе с ними отправляется на поиски волшебной звезды, исполняющей добрые желания.",
    image: threeCatGirls,
    category: "girls",
    badge: "Для девочек",
    color: colors.girls,
    textColor: textColors.girls,
    pagesDir: "three_cat_girls",
  },
  {
    id: 38,
    title: "Три Кота",
    description:
      "Встречай новых друзей и вместе с ними отправляется на поиски волшебной звезды, исполняющей добрые желания.",
    image: threeCatBoys,
    category: "boys",
    badge: "Для мальчиков",
    color: colors.boys,
    textColor: textColors.boys,
    pagesDir: "three_cat_boys",
  },

  // --- ФК Астана ---
  {
    id: 23,
    title: "ФК Астана",
    description:
      "История мальчика, который любит футбол, верит в мечту и не сдаётся.",
    image: fcAstana,
    category: "boys",
    badge: "Для мальчиков",
    color: colors.boys,
    textColor: textColors.boys,
    pagesDir: "football_astana_club",
  },

  // --- Реал Мадрид ---
  {
    id: 24,
    title: "Реал Мадрид",
    description:
      "История мальчика, который любит футбол, верит в мечту и не сдаётся.",
    image: real,
    category: "boys",
    badge: "Для мальчиков",
    color: colors.boys,
    textColor: textColors.boys,
    pagesDir: "real",
  },

  // --- ФК Кайрат ---
  {
    id: 25,
    title: "ФК Кайрат",
    description:
      "История мальчика, который любит футбол, верит в мечту и не сдаётся.",
    image: fcKairat,
    category: "boys",
    badge: "Для мальчиков",
    color: colors.boys,
    textColor: textColors.boys,
    pagesDir: "football_kairat_club",
  },

  // --- Hello Kitty и Kuromi ---
  {
    id: 26,
    title: "Hello Kitty и Kuromi",
    description: "Это история девочки, которая попала в свой дневник.",
    image: kuromi,
    category: "girls",
    badge: "Для девочек",
    color: colors.girls,
    textColor: textColors.girls,
    pagesDir: "kuromi",
  },

  // --- Маша и Медведь ---
  {
    id: 27,
    title: "Маша и Медведь",
    description: "Догони озорное тесто, пока оно не убежало!",
    image: mashaBearBoys,
    category: "boys",
    badge: "Для мальчиков",
    color: colors.boys,
    textColor: textColors.boys,
    pagesDir: "masha_bear_boys",
  },
  {
    id: 28,
    title: "Маша и Медведь",
    description: "Догони озорное тесто, пока оно не убежало!",
    image: mashaBearGirls,
    category: "girls",
    badge: "Для девочек",
    color: colors.girls,
    textColor: textColors.girls,
    pagesDir: "masha_bear_girls",
  },
];
